module.exports = __webpack_public_path__ + "img/897.84241ca9.gif";